import type { RawSearchParams } from './parse-search-params';

/**
 * Adapts platform search params into the raw shape
 * `parseFindAdvisorSearchParams` consumes. Next's `ReadonlyURLSearchParams`
 * extends `URLSearchParams`, so it is accepted without importing Next types.
 *
 * Repeated keys collapse to an array; single-occurrence keys stay strings.
 */
export function searchParamsToObject(sp: URLSearchParams): RawSearchParams {
  const obj: RawSearchParams = {};
  const seen = new Set<string>();
  for (const key of Array.from(sp.keys())) {
    if (seen.has(key)) continue;
    seen.add(key);
    const all = sp.getAll(key);
    obj[key] = all.length > 1 ? all : all[0];
  }
  return obj;
}
